<template>
  <v-container class="drop--overview--context__container pa-0">
    <v-row v-if="getSelectedResourceID.objectID !== null" class="pa-0 drop--overview--context__layout" no-gutters>
      <ShipmentsContextShippedBy
      :isLoading="selectedShipment === 'loading'"
      :shipmentDetails="selectedShipment"
      />
      <v-col class="drop--overview--context__component pa-2" cols="12">
        <ContextExpandList
        :title="$t('drops.drops')"
        :list="shipmentDrops"
        :isCustomSlot="true"
        :isHoverableActions="false"
        :closeOnSelect="false"
        >
          <template slot="customListElement" slot-scope="{ elementIndex }">
            <span class="context--expandlist__subtitle context--text--alignLeft col-20percent">
                  {{shipmentDrops[elementIndex].departure | timeToReadableTz($i18n.locale) }}-{{shipmentDrops[elementIndex].arrival | timeToReadableTz($i18n.locale) }}
            </span>
            <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
              {{shipmentDrops[elementIndex].destination.organization.name}}
            </span>
            <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
              {{shipmentDrops[elementIndex].destination.address.city}}, {{shipmentDrops[elementIndex].destination.address.countryCode}}
            </span>
            <span class="context--expandlist__subtitle context--text--alignRight col-20percent">
              {{shipmentDrops[elementIndex].weight | roundValueWeight(0)}} kg
            </span>
          </template>
        </ContextExpandList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContextExpandList from '@/components/wrld/generic/ContextExpandList'
import ShipmentsContextShippedBy from '@/components/shipments/new/ShipmentsContextShippedBy.vue'
import { mapActions, mapGetters } from 'vuex'
import { shipmentService } from '@/_services'

export default {
  name: 'ShipmentsOverviewContext',
  components: {
    ContextExpandList,
    ShipmentsContextShippedBy
  },
  props: {},
  mounted () {},
  data () {
    return {
      dropsAreLoading: true,
      dropsAlreadyFetched: false,
      expandFlag: false,
      drops: []
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedResourceID',
      'getShipmentResourceDrops',
      'getShipmentResourceDetails',
      'getShipmentIsFetching'
    ]),
    shipmentDrops: function () {
      return this.getShipmentResourceDrops != null ? this.getShipmentResourceDrops : []
    },
    selectedShipment: function () {
      if (this.getShipmentResourceDetails === null) {
        return 'loading'
      }
      // console.log(this.getShipmentResourceDetails)
      return this.getShipmentResourceDetails
    }
  },
  methods: {
    ...mapActions({
      setShipmentOverviewDrops: 'setShipmentOverviewDrops'
    }),
    async fetchDrops (dropIDs) {
      this.dropsAreLoading = true
      let drops = []
      for (let i = 0; i < dropIDs.length; i++) {
        const id = dropIDs[i]
        let fetchedDrop = null
        try {
          fetchedDrop = await shipmentService.getDropInShipment({ id: id })
          fetchedDrop = fetchedDrop.data.getDrop.drop
        } catch (error) {
          console.log('cannot fetch drop in shipment')
          this.dropsAreLoading = false
          return
        }
        const drop = {
          id: fetchedDrop.id,
          departure: fetchedDrop.departure,
          arrival: fetchedDrop.arrival,
          destination: {
            company: fetchedDrop.destination.organization,
            address: fetchedDrop.destination.address
          },
          weight: fetchedDrop.weight
        }
        drops.push(drop)
      }
      this.drops = drops
      this.dropsAlreadyFetched = true
      this.dropsAreLoading = false
    },
    handleExpand (evt) {
      if (evt.target.id === 'list_items' || evt.target.id === '') {
        if (!this.expandFlag) {
          console.log(this.getSelectedResourceID.id)
          this.setShipmentOverviewDrops({ shipmentID: this.getSelectedResourceID.id })
        }
        this.expandFlag = !this.expandFlag
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .col-10percent {
    width: 10%;
    padding-left: 5px;
  }
  .col-20percent {
    width: 20%;
    padding-left: 5px;
  }
  .col-35percent {
    width: 35%;
    padding-left: 5px;
  }
</style>
